import { render } from "./jobtab2.vue?vue&type=template&id=7bc9767a"
import script from "./jobtab2.vue?vue&type=script&lang=js"
export * from "./jobtab2.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__